import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { EmailTemplate } from '../../../types/EmailTemplate';
import { mutationKeys } from '../mutationKeys';

export const updateEmailTemplate = async (uuid: string | undefined, formData: EmailTemplate) => {
  if (!uuid) return null;
  const response = await CustomAxios.put(`email_templates/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateEmailTemplateFormProps {
  uuid?: string;
  onSuccessCallback: () => void;
}
export function useUpdateEmailTemplate({ uuid, onSuccessCallback }: UseUpdateEmailTemplateFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateEmailTemplate],
    mutationFn: (formData: EmailTemplate) => updateEmailTemplate(uuid, formData),
    onSuccess: (data: EmailTemplate) => {
      // fetch again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmailTemplates, data.uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const emailTemplate: EmailTemplate = err.response.data as EmailTemplate;
        queryClient.setQueryData([queryKeys.allEmailTemplates, emailTemplate.uuid], emailTemplate);
      }
    },
  });
}
